import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SELECTED_CLIENT_NAME,
} from "../utils/constants";

const initialState = {
  token: null,
  user: null,
  category_data: null,
  panel_projects: null,
  error: null,
  isAuthenticated: false, // Initialize to false
  selectedClientName: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user_info,
        category_data: action.payload.category_data,
        panel_projects: action.payload.panel_projects,
        isAuthenticated: true, // Set to true on successful login
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload,
        isAuthenticated: false, // Set to false on login failure
      };
    case SELECTED_CLIENT_NAME:
      return {
        ...state,
        selectedClientName: action.payload || "",
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        user: null,
        category_data: null,
        panel_projects: null,
        isAuthenticated: false, // Reset to false on logout
        selectedClientName: "",
      };
    default:
      return state;
  }
};

export default authReducer;
